import { FunctionField, Labeled } from "react-admin";
import CopyButton from "./CopyButton";

const CopyField = ({ source, label }) => (
  <Labeled>
    <FunctionField source={source} label={label || undefined} render={record =>
      record[source] ?
        <span>
          {record[source]} <CopyButton copyText={record[source]} />
        </span>
      : <span>N/A</span>
    } />
  </Labeled>
);

export default CopyField;
